import { useLocation } from 'react-router';

import StudioShellHeader from '@cartwhl/ui/layout/StudioShellHeader';

import type { AppletLayoutProps } from '../applets';

/** Batch tools (and future home) shell: fixed chrome + scrollable main. */
export default function StudioShellLayout({
  children,
  title,
  subtitle,
}: AppletLayoutProps) {
  const { pathname } = useLocation();

  return (
    <div className="bg-primary flex h-dvh max-h-dvh min-h-0 flex-col overflow-hidden">
      <StudioShellHeader
        title={title}
        subtitle={subtitle?.trim() || undefined}
        currentPathname={pathname}
        currentSurface="apps"
        appletHeader
      />
      <main className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        {children}
      </main>
    </div>
  );
}
